import { render, staticRenderFns } from "./PasswordPage.vue?vue&type=template&id=457bda4e&scoped=true&"
import script from "./PasswordPage.vue?vue&type=script&lang=js&"
export * from "./PasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457bda4e",
  null
  
)

export default component.exports